import React, { useEffect, useState } from "react";
import { formateDateTime } from "../../utils";
import Avatar from "../../static/images/home.png";
import { ChatEvents, MessageType, Roles } from "../../constants";
import { createImageFromInitials } from "../../AgentLogo";
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";


function JsonTemplate({
    message,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    ViewPlanDetails
}) {

    const [viewMore, setViewMore] = useState(false)
    const content = JSON.parse(message.content);
    useEffect(() => {
        if (content.choices && content.choices.length > 4 && !message.selected) {
            setViewMore(true)
        }
    })
    // console.log(message.displayAllOptions)
    return (
        <>
            {content.type && content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}

            {content.type && content.type.toLowerCase() === "selection" ?
                <>
                    {content.title ? (
                        <>
                            <div className="grop_message">
                                <div
                                    className="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>
                            {message.selected ?
                                null
                                : <>
                                    <div className="grop_message usericon">

                                        <img src={Avatar} alt=""></img>

                                    </div>
                                    <div className="grop_message entete">
                                        <h3>{formateDateTime(message.sentAt)}</h3>
                                    </div>
                                </>
                            }
                        </>
                    ) : null}
                    {message.selected ? null : (
                        <>
                            <div className="mcq">
                                {content.choices.map((item1, index) => (
                                    <>
                                        {message.displayAllOptions || index < 3 || !viewMore ?
                                            <>
                                                <span onClick={() => selectOption(item1, content.type, message.messageId)} >
                                                    {item1.display_value}
                                                </span>
                                                <span className="clear"></span>
                                            </>
                                            : null}
                                    </>
                                ))}
                                {viewMore && !message.displayAllOptions ?
                                    // <div className="grop_message tabq">
                                    <>
                                        <span onClick={() => displayAllOptions(message.messageId)} className="">
                                            {"View More"}
                                        </span>
                                        <span className="clear"></span>
                                    </>
                                    // </div>
                                    : null}
                            </div>
                        </>
                    )}
                </>
                : null}

        </>
    );
}

export default function HomeAgentMessage({
    messages,
    agentName,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    AgentMsg,
    ViewPlanDetails
}) {
    return (
        <li className="you">
            {messages.map((item) => (
                <>
                    {item.type.toLowerCase() === "json" ? (
                        <JsonTemplate
                            message={item}
                            displayAllOptions={displayAllOptions}
                            GAEvent={GAEvent}
                            showPlansComparison={showPlansComparison}
                            regenDoc={regenDoc}
                            selectOption={selectOption}
                            contactSupport={contactSupport}
                            mainMenu={mainMenu}
                            AgentMsg={AgentMsg}
                            ViewPlanDetails={ViewPlanDetails}
                        ></JsonTemplate>
                    ) : (
                        <>
                            {item.type === MessageType.html ? (
                                <div className="grop_message">
                                    <div
                                        className="message"
                                        dangerouslySetInnerHTML={{
                                            __html: item.content,
                                        }}
                                    >
                                        {" "}
                                    </div>
                                </div>
                            ) : (
                                <div className="grop_message">
                                    <div className="message">{item.content} </div>
                                </div>
                            )}
                        </>
                    )}
                </>
            ))}
            {messages[messages.length - 1].type && messages[messages.length - 1].type.toLowerCase() === MessageType.json && !messages[messages.length - 1].selected ? null :
                <>
                    <div className="grop_message usericon">
                        {AgentMsg ? (
                            <img
                                id="preview"
                                src={
                                    createImageFromInitials(500, agentName, "blue") // getRandomColor()
                                }
                                alt="profile-pic"
                            />
                        ) : (
                            <img src={Avatar} alt=""></img>
                        )}
                    </div>
                    <div className="grop_message entete">
                        <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
                    </div>
                </>
            }
        </li>
    );
}
